import './App.css';

import Home from './components/Home';

import { BrowserRouter, Route, Routes } from "react-router-dom";

import Contact2 from './components/Contact/Contact';
import TopBar from './components/TopBar';
import NavBar3 from './components/Navbar3';
import Footer from './components/Footer';
import Services2 from './components/Services2';
import React, { useState, useEffect } from 'react';

// import {ThreeDots } from 'react-loader-spinner'; // Note the use of { Loader } instead of default import

// import Loader from './components/Loader';
import Circles, { Audio, InfinitySpin, ThreeDots } from 'react-loader-spinner'; // Note the use of { Loader } instead of default import

import Career from './components/Company/Career';
import About from './components/Company/About';


import ProjectCard from './components/Portfolio/ProjectCard';






function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate an async operation (e.g., loading data or resources)
    setTimeout(() => {
      setIsLoading(false); // Set isLoading to false when done loading
    }, 2000); // Adjust the delay as needed
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top when the route changes
  }, []);
  return (
    <>
      {isLoading ? (
        <div className="centered-loader">
          <div className="loader-container">
            <ThreeDots
              height="80"
              width="80"
              radius="9"
              color="#4fa94d"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={true}
            />
            <p>Loading...</p>
          </div>
        </div>
      ) : (
        <BrowserRouter>
          {/* <Navbar/> */}
          <TopBar />
          {/* <Navbar2/> */}
          <NavBar3 />


          {/* <Home/> */}
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/home" element={<Home />} />
            <Route exact path='/services' element={<Services2 />} />
            <Route exact path='/contact' element={<Contact2 />} />
            <Route exact path='/careers' element={<Career />} />
            <Route exact path='/company' element={<About />} />

            {/* <Route exact path='/company' element={<About/>}/> */}

            <Route exact path='/portfolio' element={<ProjectCard />} />
            <Route exact path='/company' element={<About />} />




          </Routes>
          <Footer />
        </BrowserRouter>
      )}


    </>
  );
}

export default App;